import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhotoContainer } from '@app/my-zone/shared/photo/photo.container';
import { TableListModule } from '@app/my-zone/shared/table-list/table-list.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { PhotoContentComponent } from './photo-content/photo-content.component';
import { PhotoDownloadComponent } from './photo-download/photo-download.component';
import { PhotoComponent } from './photo.component';

@NgModule({
    declarations: [
        PhotoComponent,
        PhotoDownloadComponent,
        PhotoContainer,
        PhotoContentComponent,
    ],
    imports: [
        CommonModule,
        PipesModule,
        TableListModule,
    ],
    exports: [
        PhotoContainer,
    ],
})
export class PhotoModule {}
